import type { ReactNode } from "react";
import { token } from "@/design/theme";

/** A consistent screen header (title + subtitle + end actions) used across LIS screens. */
export function PageHeader({
  title,
  subtitle,
  actions,
}: {
  title: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
}) {
  return (
    <header
      style={{
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "space-between",
        gap: token.s4,
        flexWrap: "wrap",
        marginBlockEnd: token.s5,
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: token.s1 }}>
        <h1 style={{ fontSize: token.fsH1 }}>{title}</h1>
        {subtitle && (
          <p style={{ margin: 0, color: token.slate, fontSize: token.fsBody }}>{subtitle}</p>
        )}
      </div>
      {actions && <div style={{ display: "flex", gap: token.s2 }}>{actions}</div>}
    </header>
  );
}
